"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.ListContext = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = _interopRequireDefault(require("../styles"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _tokens = require("../styles/tokens");

var _globalSpacing = require("./../globalSpacing");

var _globalSpacing2 = require("../globalSpacing");

var _excluded = ["classes", "spacingOptions"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  return {
    root: {
      backgroundColor: theme.palette.common.white,
      width: _tokens.widthFluid
    }
  };
};

var ListContext = /*#__PURE__*/(0, _react.createContext)();
/**
 * Use `List` to display a continuous, vertical index of text and/or images.
 * @done true
 * @updated v6.5.0
 * @versionAdded v0.0.15
 * @examples
 *  PrimaryTextExample
 *  SecondaryTextExample
 *  ControlsExample
 *  ListItemWithButtonExample
 *  IconsExample
 *  ComplexListExample
 *  MultilineExample
 *  NestedOptionsExample
 */

exports.ListContext = ListContext;

var List = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
      spacingOptionsLocal = props.spacingOptions,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var spacingOptions = (0, _globalSpacing.getSpacingOptions)(spacingOptionsLocal);
  var classOverrides = (0, _extends2.default)({
    // Style overrides
    root: classes.root
  }, classes);
  return /*#__PURE__*/_react.default.createElement(ListContext.Provider, {
    value: {
      spacingOptions: spacingOptions
    }
  }, /*#__PURE__*/_react.default.createElement(_List.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    ref: ref
  })));
});

List.muiName = 'List';
List.displayName = 'List';
List.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items. The property is available to descendant components as the
   * `dense` context.
   */
  dense: _propTypes.default.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: _propTypes.default.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: _propTypes.default.node,

  /**
   * Override global spacing options.
   * Available options are:
   * * `spacing: 'standard' | 'none'`
   *      * Controls the padding around the `ListItems`.
   */
  spacingOptions: _propTypes.default.shape({
    spacing: _propTypes.default.string
  })
};
List.defaultProps = {
  dense: false,
  disablePadding: true,
  spacingOptions: {
    spacing: _globalSpacing2.spacingVariant.STANDARD
  }
};

var _default = (0, _styles.default)(styles)(List);

exports.default = _default;